import { DMEData, generalSettings, registerWidget } from "dmeditor";
import { Twitter } from "./Twitter";

const register = () => {
  registerWidget(
    {
      type: "twitter",
      icon: "",
      name: "Twitter",
      category: "basic",
      settings: [
        {
          name: "Twitter url",
          property: ".url",
          settingComponent: "input",
        },
        {
          name: "Height",
          property: ".height",
          settingComponent: "number",
        },
      ],
      events: {
        updateData: () => {},
        createBlock: (): DMEData.CreatedBlock => {
          return {
            type: "twitter",
            data: { url: "TSSCollegeBound", list: [] },
          };
        },
      },
    },
    {
      render: Twitter,
    }
  );
};

export default register;
